import React from "react";
import CheckIcon from "../../assets/checkbox.svg";
import { isLanguageEnglish } from "../Common/utils";

const SignatoryTable = ({ user, t, i18n, userIdx }) => {
  const renderCountries = (auth) => {
    return auth?.country?.map((element, index) => (
      <span key={index}>({element?.country || element})</span>
    ));
  };

  const getName = (auth) => {
    const { firstName, lastName } = auth;
    return isLanguageEnglish(i18n.language)
      ? `${firstName} ${lastName}`
      : `${lastName} ${firstName}`;
  }

  return (
    <>
      {user.authorizedSignatories.map((auth, index) => {
        if (index >= user.authorizedSignatoriesCount) {
          return null;
        }
        return (
          <div key={index} className="margin-2-b">
            <h4 className="pad-2-t">
              {t("confirm.signatory")} {renderCountries(auth)}
              {(userIdx >= 0) && (
                <span className="margin-1-l dls-bright-blue">
                  {t("confirm.useraccess")} {userIdx + 1}
                </span>
              )}
            </h4>
            <table>
              <tbody>
                <tr>
                  <td className="labelName">
                    <b>{t("confirm.name")}:</b>
                  </td>
                  <td className="labelValue">
                    {getName(auth)}
                  </td>
                </tr>
                <tr>
                  <td className="labelName">
                    <b>
                      {user.country === t("access.UNITEDKINGDOM")
                        ? t("common.TelephoneNumber")
                        : t("confirm.phno")}
                      :
                    </b>
                  </td>
                  <td className="labelValue">{auth.phoneNumber}</td>
                </tr>
                <tr>
                  <td className="labelName">
                    <b>
                      {user.country === t("access.UNITEDKINGDOM")
                        ? t("common.EmailAddress")
                        : t("confirm.businessemail")}
                      :
                    </b>
                  </td>
                  <td className="labelValue">{auth.emailId}</td>
                </tr>
                <tr>
                  <td className="labelName">
                    <b>{t("newuser.position")}:</b>
                  </td>
                  <td className="labelValue">{auth.position}</td>
                </tr>
              </tbody>
            </table>
            <h5 className="termsAndConditionsText">
              <b>{t("confirm.t&c")}</b>
            </h5>
            <img src={CheckIcon} alt="icon" />{" "}
            <span>
              {getName(auth)}
              <b> {t("confirm.agree-t&c")}</b>
            </span>
          </div>
        )
      })}
    </>
  );
};

export default SignatoryTable;
